import React, {Fragment} from 'react';
import PageTitle from '../../../Layout/AppMain/PageTitle';
import Tabs from 'react-responsive-tabs';

import Familia from './component/Familia';

export default class FamiliaComponent extends React.Component {

    render() {

        return (
            <Familia/>
        );
    }
}


// WEBPACK FOOTER //
// src/Pages/Demografico/Familia/index.js